import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Терапія ПЛЮС - список аптек і препарати в програмі «ТерапіяПЛЮС»",
      description: "Програма підтримки  пацієнтів з гострими хронічними захворюваннями в таких областях, як кардіологія, ендокринологія, нефрологія та пульмонологія."
    }

  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
    meta: {
      title: "Терапія ПЛЮС - список аптек і препарати в програмі «ТерапіяПЛЮС»",
      description: "Програма підтримки  пацієнтів з гострими хронічними захворюваннями в таких областях, як кардіологія, ендокринологія, нефрологія та пульмонологія."
    }
  },
  {
    path: "/registration",
    name: "Registration",
    component: () => import("../views/Registration.vue"),
    meta: {
      title: "Терапія ПЛЮС - список аптек і препарати в програмі «ТерапіяПЛЮС»",
      description: "Програма підтримки  пацієнтів з гострими хронічними захворюваннями в таких областях, як кардіологія, ендокринологія, нефрологія та пульмонологія."
    }
  },
  {
    path: "/pharmacies",
    name: "Pharmacies",
    component: () => import("../views/Pharmacies.vue"),
    meta: {
      title: "Терапія ПЛЮС - список аптек і препарати в програмі «ТерапіяПЛЮС»",
      description: "Програма підтримки  пацієнтів з гострими хронічними захворюваннями в таких областях, як кардіологія, ендокринологія, нефрологія та пульмонологія."
    }
  },
  {
    path: "/information",
    name: "Information",
    component: () => import("../views/Information.vue"),
    meta: {
      title: "Терапія ПЛЮС - список аптек і препарати в програмі «ТерапіяПЛЮС»",
      description: "Програма підтримки  пацієнтів з гострими хронічними захворюваннями в таких областях, як кардіологія, ендокринологія, нефрологія та пульмонологія."
    }
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: () => import("../views/Contacts.vue"),
    meta: {
      title: "Терапія ПЛЮС - список аптек і препарати в програмі «ТерапіяПЛЮС»",
      description: "Програма підтримки  пацієнтів з гострими хронічними захворюваннями в таких областях, як кардіологія, ендокринологія, нефрологія та пульмонологія."
    }
  },

  {
    path: "/adverse-reaction",
    name: "AdverseReaction",
    component: () => import("../views/AdverseReaction.vue"),
    meta: {
      title: "Терапія ПЛЮС - список аптек і препарати в програмі «ТерапіяПЛЮС»",
      description: "Програма підтримки  пацієнтів з гострими хронічними захворюваннями в таких областях, як кардіологія, ендокринологія, нефрологія та пульмонологія."
    }
  },
  {
    path: "/terms-and-conditions",
    name: "Conditions",
    component: () => import("../views/Conditions.vue"),
    meta: {
      title: "Терапія ПЛЮС - список аптек і препарати в програмі «ТерапіяПЛЮС»",
      description: "Програма підтримки  пацієнтів з гострими хронічними захворюваннями в таких областях, як кардіологія, ендокринологія, нефрологія та пульмонологія."
    }
  },
  {
    path: "/policy",
    name: "Policy",
    component: () => import("../views/Policy.vue"),
    meta: {
      title: "Терапія ПЛЮС - список аптек і препарати в програмі «ТерапіяПЛЮС»",
      description: "Програма підтримки  пацієнтів з гострим хронічмими захворюваннями в таких областях, як кардіологія, ендокринологія, нефрологія та пульмонологія."
    }
  },
  {
    path: "/copd",
    name: "copd",
    component: () => import("../views/copd.vue"),
    meta: {
      title: "Терапія ПЛЮС - Пульмонологія",
      description: "Програма підтримки пацієнтів для пацієнтів із хронічним обструктивним захворюванням легень."
    }
  },
      {
        path: "/bronchial-asthma",
        name: "BronchialAsthma",
        component: () => import("../views/BronchialAsthma.vue"),
        meta: {
          title: "Терапія ПЛЮС - Бронхіальна астма",
          description: "Програма підтримки пацієнтів для пацієнтів із бронхіальною астмою."
        }
      },
  {
    path: "/myocardial-infarction",
    name: "MyocardialInfarction",
    component: () => import("../views/MyocardialInfarction.vue"),
    meta: {
      title: "Терапія ПЛЮС - Кардіо - Інфаркт Міокарда",
      description: "Програма підтримки пацієнтів для пацієнтів із захворюванням інфаркт міокарда."
    }
  },
  {
    path: "/ischemic-heart-disease",
    name: "IschemicHeartDisease",
    component: () => import("../views/IschemicHeartDisease.vue"),
    meta: {
      title: "Терапія ПЛЮС - Кардіо - Ішемічна хороба серця",
      description: "Програма підтримки пацієнтів для пацієнтів із захворюванням ішемічна хвороба серця."
    }
  },
  {
    path: "/endocrinology",
    name: "endocrinology",
    component: () => import("../views/Endocrinology.vue"),
    meta: {
      title: "Терапія ПЛЮС - Ендокринологія",
      description: "Програма підтримки пацієнтів для пацієнтів із захворюванням цукрового діабету 2-го типу."
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash !== "" && to.hash !== "#") {
      var elementId = to.hash.substring(1);

      var scrollOffset = document.getElementById(elementId).offsetTop;
      return { x: 0, y: scrollOffset };
    } else {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    }
  }
});

// Додайте навігаційний охоронець для встановлення title та description
router.beforeEach((to, from, next) => {
  // Встановлення title
  document.title = to.meta.title || 'Ваш сайт'; // Замініть на назву за замовчуванням

  // Встановлення meta description
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', to.meta.description || 'Опис вашого сайту за замовчуванням');
  } else {
    const meta = document.createElement('meta');
    meta.name = 'description';
    meta.content = to.meta.description || 'Опис вашого сайту за замовчуванням';
    document.head.appendChild(meta);
  }

  next();
});

export default router;
